{
  "familyId": "GET-ROND-BASIS",
  "questions": [
    {
      "id": "GET-ROND-BASIS-001",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "De school heeft 47 stoelen besteld. De leverancier rondt af op tientallen. Hoeveel stoelen schrijft hij op?",
      "context": null,
      "options": ["50", "40", "45", "47"],
      "correctAnswer": 0,
      "conceptId": "round_tens_up",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 40,
            "max": 50,
            "value": 47,
            "step": 10,
            "label": "47 op de getallenlijn tussen 40 en 50"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op tientallen",
            "content": "Kijk naar het eenheidscijfer. Is het 5 of hoger? Rond dan omhoog naar het volgende tiental. Is het lager dan 5? Rond dan omlaag naar het vorige tiental."
          }
        },
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 40,
            "max": 50,
            "value": 47,
            "step": 10,
            "label": "47 ligt dichter bij 50 dan bij 40"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 50. Het eenheidscijfer van 47 is 7. De afrondregel: 7 ≥ 5, dus we ronden omhoog. 47 → 50.",
        "distractorExplanations": {
          "0": "Goed! Eenheidscijfer 7 ≥ 5, dus omhoog afronden: 47 → 50.",
          "1": "40 is fout. Je hebt omlaag afgerond, maar het eenheidscijfer is 7 (≥ 5). De afrondregel zegt: bij 5 of hoger ga je omhoog. Dus 47 → 50, niet 40.",
          "2": "45 is geen tiental. Bij afronden op tientallen is het antwoord altijd een veelvoud van 10 (10, 20, 30, 40, 50...). Je hebt het getal halverwege genomen in plaats van naar het dichtstbijzijnde tiental te gaan.",
          "3": "47 is het getal zelf — je hebt helemaal niet afgerond. Afronden betekent dat je naar het dichtstbijzijnde tiental gaat: 47 → 50."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-002",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "In de klas zitten 83 boeken op de plank. De juf rondt af op tientallen voor haar lijst. Welk getal schrijft ze op?",
      "context": null,
      "options": ["80", "90", "85", "83"],
      "correctAnswer": 0,
      "conceptId": "round_tens_down",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.7,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 80,
            "max": 90,
            "value": 83,
            "step": 10,
            "label": "83 op de getallenlijn tussen 80 en 90"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op tientallen",
            "content": "Kijk naar het eenheidscijfer. Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag."
          }
        },
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 80,
            "max": 90,
            "value": 83,
            "step": 10,
            "label": "83 ligt dichter bij 80 dan bij 90"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 80. Het eenheidscijfer van 83 is 3. De afrondregel: 3 < 5, dus we ronden omlaag. 83 → 80.",
        "distractorExplanations": {
          "0": "Goed! Eenheidscijfer 3 < 5, dus omlaag afronden: 83 → 80.",
          "1": "90 is fout. Je hebt omhoog afgerond, maar het eenheidscijfer is 3 (< 5). De afrondregel zegt: bij lager dan 5 ga je omlaag. Dus 83 → 80, niet 90.",
          "2": "85 is geen tiental. Je hebt het getal halverwege genomen in plaats van naar het dichtstbijzijnde tiental te gaan. Het antwoord moet een veelvoud van 10 zijn: 80 of 90.",
          "3": "83 is het getal zelf — je hebt helemaal niet afgerond. Afronden betekent dat je naar het dichtstbijzijnde tiental gaat: 83 → 80."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-003",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Op een schoolfeest zijn 65 leerlingen. De directeur rondt af op tientallen voor zijn verslag. Welk getal schrijft hij op?",
      "context": null,
      "options": ["70", "60", "65", "75"],
      "correctAnswer": 0,
      "conceptId": "round_tens_five",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 60,
            "max": 70,
            "value": 65,
            "step": 10,
            "label": "65 precies in het midden tussen 60 en 70"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden bij eenheidscijfer 5",
            "content": "Als het eenheidscijfer precies 5 is, ronden we altijd omhoog. Dit is de standaard afrondregel in Nederland."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 70. Het eenheidscijfer van 65 is 5. De afrondregel: bij 5 of hoger ronden we altijd omhoog. Dus 65 → 70.",
        "distractorExplanations": {
          "0": "Goed! Eenheidscijfer 5 → altijd omhoog afronden → 65 → 70.",
          "1": "60 is fout. Je hebt omlaag afgerond, maar de afrondregel zegt: bij een eenheidscijfer van 5 ronden we altijd omhoog. Dus 65 → 70, niet 60.",
          "2": "65 is het getal zelf — je hebt helemaal niet afgerond. Afronden betekent dat je naar het dichtstbijzijnde tiental gaat. Bij eenheidscijfer 5 ga je altijd omhoog: 65 → 70.",
          "3": "75 is geen tiental. Je hebt het getal met 10 opgeteld in plaats van naar het dichtstbijzijnde tiental te gaan. Het antwoord moet een veelvoud van 10 zijn: 60 of 70."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-004",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Een winkel heeft 347 pakken melk verkocht. De eigenaar rondt af op honderdtallen voor zijn rapport. Welk getal schrijft hij op?",
      "context": null,
      "options": ["300", "400", "350", "340"],
      "correctAnswer": 0,
      "conceptId": "round_hundreds_down",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 300,
            "max": 400,
            "value": 347,
            "step": 100,
            "label": "347 op de getallenlijn tussen 300 en 400"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Kijk naar het tientalcijfer (het middelste cijfer). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag."
          }
        },
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 300,
            "max": 400,
            "value": 347,
            "step": 100,
            "label": "347 ligt dichter bij 300 dan bij 400"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 300. Bij afronden op honderdtallen kijk je naar het tientalcijfer. In 347 is het tientalcijfer 4. De afrondregel: 4 < 5, dus we ronden omlaag. 347 → 300.",
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 4 (< 5) → omlaag afronden: 347 → 300.",
          "1": "400 is fout. Je hebt omhoog afgerond, maar het tientalcijfer is 4 (< 5). De afrondregel zegt: bij lager dan 5 ga je omlaag. Dus 347 → 300, niet 400. Verwar het tientalcijfer (4) niet met het eenheidscijfer (7).",
          "2": "350 is geen honderdtal. Je hebt afgerond op tientallen in plaats van honderdtallen. Bij afronden op honderdtallen is het antwoord altijd een veelvoud van 100 (100, 200, 300, 400...).",
          "3": "340 is een tiental, geen honderdtal. Je hebt het eenheidscijfer weggegooid maar niet verder afgerond op honderdtallen. Het antwoord moet een veelvoud van 100 zijn: 300 of 400."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-005",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Een school heeft 782 leerlingen. De gemeente rondt af op honderdtallen voor de statistieken. Welk getal staat in het rapport?",
      "context": null,
      "options": ["800", "700", "780", "790"],
      "correctAnswer": 0,
      "conceptId": "round_hundreds_up",
      "variantIndex": 5,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.7,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 700,
            "max": 800,
            "value": 782,
            "step": 100,
            "label": "782 op de getallenlijn tussen 700 en 800"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Kijk naar het tientalcijfer. Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 800. In 782 is het tientalcijfer 8. De afrondregel: 8 ≥ 5, dus we ronden omhoog. 782 → 800.",
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 8 (≥ 5) → omhoog afronden: 782 → 800.",
          "1": "700 is fout. Je hebt omlaag afgerond, maar het tientalcijfer is 8 (≥ 5). De afrondregel zegt: bij 5 of hoger ga je omhoog. Dus 782 → 800, niet 700.",
          "2": "780 is een tiental, geen honderdtal. Je hebt het eenheidscijfer weggegooid maar niet verder afgerond op honderdtallen. Kijk naar het tientalcijfer (8 ≥ 5) → 782 → 800.",
          "3": "790 is ook een tiental, geen honderdtal. Het antwoord moet een veelvoud van 100 zijn. Kijk naar het tientalcijfer (8 ≥ 5) → 782 → 800."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-006",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Een sportvereniging heeft 550 leden. De voorzitter rondt af op honderdtallen voor het jaarverslag. Welk getal schrijft hij op?",
      "context": null,
      "options": ["600", "500", "550", "560"],
      "correctAnswer": 0,
      "conceptId": "round_hundreds_fifty",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 500,
            "max": 600,
            "value": 550,
            "step": 100,
            "label": "550 precies in het midden tussen 500 en 600"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden bij tientalcijfer 5",
            "content": "Als het tientalcijfer precies 5 is, ronden we altijd omhoog naar het volgende honderdtal."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 600. In 550 is het tientalcijfer 5. De afrondregel: bij 5 of hoger ronden we altijd omhoog. Dus 550 → 600.",
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 5 → altijd omhoog afronden → 550 → 600.",
          "1": "500 is fout. Je hebt omlaag afgerond, maar de afrondregel zegt: bij een tientalcijfer van 5 ronden we altijd omhoog. Dus 550 → 600, niet 500.",
          "2": "550 is het getal zelf — je hebt helemaal niet afgerond. Afronden op honderdtallen betekent dat je naar het dichtstbijzijnde honderdtal gaat. Bij tientalcijfer 5 ga je altijd omhoog: 550 → 600.",
          "3": "560 is een tiental, geen honderdtal. Je hebt het eenheidscijfer weggegooid maar niet verder afgerond op honderdtallen. Het antwoord moet een veelvoud van 100 zijn: 500 of 600."
        }
      }
    }
  ]
}